import { render, staticRenderFns } from "./verification_list.vue?vue&type=template&id=df10a4ba&scoped=true&"
import script from "./verification_list.vue?vue&type=script&lang=js&"
export * from "./verification_list.vue?vue&type=script&lang=js&"
import style0 from "./verification_list.vue?vue&type=style&index=0&id=df10a4ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df10a4ba",
  null
  
)

export default component.exports